export default __webpack_public_path__ + "static/media/profileImg4.c7f02dd3.png";